export default "__VITE_ASSET__39522dee__"